<template>
  <CustomModal
    id="my-card-share-setup-modal"
    class="basic-modal"
    :title="'공개 범위 설정'"
    :okTitle="'저장'"
    @ok="onModalOkClick(selectedMyCardShareLevel)"
    @cancel="onModalCancelClick"
    :okBusy="isLoading"
    :okDisabled="isLoading"
  >
    <div class="display-block">
      <Radio
        id="private"
        @change="handleShareLevelChange(2)"
        :model-value="selectedMyCardShareLevel"
        v-bind:check-value="2"
      >
        <span slot="label">비공개</span>
      </Radio>
    </div>
    <div class="display-block">
      <Radio
        id="public"
        @change="handleShareLevelChange(3)"
        :model-value="selectedMyCardShareLevel"
        v-bind:check-value="3"
      >
        <span slot="label">소속 기관에만 공개</span>
      </Radio>
    </div>
    <div class="display-block">
      <Radio
        id="academy"
        @change="handleShareLevelChange(1)"
        :model-value="selectedMyCardShareLevel"
        v-bind:check-value="1"
      >
        <span slot="label">전체 공개</span>
      </Radio>
    </div>
    <div class="display-block" v-if="isPublisher">
      <Radio
        id="hidden"
        @change="handleShareLevelChange(99)"
        :model-value="selectedMyCardShareLevel"
        v-bind:check-value="99"
      >
        <span slot="label">숨기기</span>
      </Radio>
    </div>
  </CustomModal>
</template>

<script>
  export default {
    name: 'my-card-share-setup-modal',

    props: {
      cardShareLevel: {
        type: Number,
        default: 0,
      },
      onModalOkClick: {
        type: Function,
      },
      onModalCancelClick: {
        type: Function,
      },
      isLoading: {
        type: Boolean,
      },
      isPublisher: {
        type: Boolean,
      },
    },

    data() {
      return {
        selectedMyCardShareLevel: 0,
      };
    },

    methods: {
      handleShareLevelChange(shareLevel) {
        this.selectedMyCardShareLevel = shareLevel;
      },
    },

    beforeMount() {
      this.selectedMyCardShareLevel = this.cardShareLevel;
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/my-cards/components/MyCardShareSetupModal.vue